import request from "@/utils/request";

export default function listMerchantNewsTypeTemplates(merchantId) {
    return request({
        url: `/merchantNewsMessageTemplate/agency/list/`+merchantId,
        method: 'get',
    })
}
